import { Timestamp } from "firebase/firestore";

export interface Payment {
  paymentAmount: string;
  paymentType: "cash" | "kaspi" | "halyk";
}

export interface Mechanic {
  id: string;
  fullName: string;
  role: string;
  relatedObjectField: {
    name: string;
    price: string | number;
    duration: string;
  }[];
}

export interface Order {
  id: string;
  dateCreated: Timestamp;
  mechanics: Mechanic[];
  parts: Mechanic[];
  payments: Payment[] | string;
  totalPrice: string;
  status: string;
}

export interface WorkDataItem {
  employeeId: string;
  employeeName: string;
  date: string;
  amount: number;
}

export interface PaymentDataItem {
  date: string;
  dateCreated: Date;
  cash: number;
  kaspi: number;
  halyk: number;
}

export interface Expense {
  id: string;
  date: Timestamp;
  text: string;
  amount: number;
}

export const formatEmployeeName = (fullName: string): string => {
  if (!fullName) return "";

  const nameParts = fullName.split(" ");
  if (nameParts.length < 2) return fullName;

  const lastName = nameParts[0];
  const firstName = nameParts[1];

  return `${lastName} ${firstName.charAt(0)}.`;
};
